module.exports = __webpack_public_path__ + "img/input-left.2d375afc.png";